import { ReactElement } from 'react';
import cn from 'classnames';

import styles from './AmountButton.module.scss';
import { getDataTest } from '../../utils/dataTests';

interface AmountButtonProps {
    onClick: () => void;
    actionType?: 'increase' | 'decrease';
    text?: string;
    title?: string;
    className?: string;
}

export const AmountButton = ({
    text,
    actionType = 'increase',
    onClick,
    title,
    className,
    ...props
}: AmountButtonProps): ReactElement | null => {
    return (
        <button
            type="button"
            className={cn(styles.wrapper, className)}
            onClick={onClick}
            title={title ?? undefined}
            {...props}
        >
            <div
                className={cn(styles.icon, actionType === 'increase' ? styles.increase : styles.decrease)}
                data-test={getDataTest(props, 'Icon')}
            />
            {text && (
                <span className={styles.text} data-test={getDataTest(props, 'Text')}>
                    {text}
                </span>
            )}
        </button>
    );
};
